import {useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography"
import CustomersTable from "./customers-table/CustomersTable";
import GenericDialog from "../../../ui/dialogs/generic-dialog/GenericDialog";
import Domain from "@material-ui/icons/Domain";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import {Button, Input, InputLabel, useMediaQuery} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Search} from "@material-ui/icons";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../../../store";
import useProgressiveInput from "../../../../hooks/useProgressiveInput";
import PropTypes from "prop-types";
import {OPERATOR} from "../../../../shared/utils/constants/storage";

const CustomersDialog = (props) => {
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [isApplicaDisabled, setIsApplicaDisabled] = useState(true);
    const [setTimeoutCustomers, clearTimeoutCustomers] = useProgressiveInput(() => fetchCompaniesProp(0, 5), 1000)
    const matches = useMediaQuery((theme) => theme.breakpoints.down('xs'))
    const dispatch = useDispatch()
    const selectedCompany = useSelector((state) => state.authReducer.selectedCompany)
    const searchText = useSelector((state) => state.authReducer.companies.searchText)
    const loading = useSelector((state) => state.authReducer.companies.loading)
    const page = useSelector((state) => state.authReducer.companies.page)
    const companyId = useSelector(state => state.authReducer.userClaims.companyId)
    const userType = useSelector(state => state.authReducer.userClaims.typeUser);

    const handleSearchChange = (e) => {
        dispatch(actions.setFilterCompanies(e.target.value))
        setTimeoutCustomers();
    }


    const fetchCompaniesProp = (page, rowsPerPage) => {
        if (userType === OPERATOR) {
            dispatch(actions.fetchCompanies(page, rowsPerPage))
        } else {
            dispatch(actions.fetchCompanies(page, rowsPerPage, companyId))
        }
    }

    const handleApplicaClick = () => {
        dispatch(actions.setSelectedCompany(selectedCustomer))
        handleDialogClose()
    }

    // return once we select a default company
    useEffect(() => {
        setSelectedCustomer(selectedCompany.integrationId)
    }, [selectedCompany])

    const handleDialogClose = () => {
        if (page !== 0 || searchText !== "") {
            dispatch(actions.setFilterCompanies(""))
            fetchCompaniesProp(0, 5);
        }
        props.handleDialogClose();
    }


    const handleSearchKeyPress = (e) => {
        if (e.which === 13) {
            clearTimeoutCustomers();
            fetchCompaniesProp(0, 5);
        }
    }

    const handleSearchIconClick = (e) => {
        e.preventDefault();
        clearTimeoutCustomers()
        fetchCompaniesProp(0, 5);
    }


    const dialogContent = (
        <>
            {!loading ? <Grid container className="mt-6">
                <Grid container alignItems="center" justifyContent={"flex-start"} item
                      xs={12} sm={6}>
                    <div className="mr-8">
                        <Domain fontSize={"large"}/>
                    </div>
                    <div>
                        <Typography variant="subtitle2">{selectedCompany.integrationId}</Typography>
                        <Typography variant="button">{selectedCompany.name}</Typography>
                    </div>
                </Grid>
                <Grid container justifyContent={"flex-end"} item xs={12} sm={6}>
                    <FormControl fullWidth={matches}>
                        <InputLabel id="filterSearchLabelCompanies" style={{color: "#ccc"}}>Search</InputLabel>
                        <Input labelid="filterSearchLabelCompanies"
                               id="filterSearchSim"
                               value={searchText}
                               onChange={handleSearchChange}
                               onKeyPress={handleSearchKeyPress}
                               autoFocus
                               type="search"
                               endAdornment={
                                   <InputAdornment id="searchIconSIM" position="end" onClick={handleSearchIconClick}>
                                       <Search id="filterSearchIconSim"/>
                                   </InputAdornment>
                               }/>
                    </FormControl>
                </Grid>
            </Grid> : null}

            <CustomersTable
                selectedCustomer={selectedCustomer}
                setIsApplicaDisabled={setIsApplicaDisabled}
                setSelectedCustomer={setSelectedCustomer}
                fetchData={fetchCompaniesProp}/>
        </>
    );

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button autoFocus onClick={props.handleDialogClose} color="primary" variant="outlined">
                Annulla
            </Button>
            <Button
                autoFocus
                color="primary"
                variant="contained"
                onClick={handleApplicaClick}
                disabled={isApplicaDisabled}
            >
                Applica
            </Button>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={handleDialogClose}
            handleDialogCloseButton={handleDialogClose}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <Typography variant={"h6"}>Seleziona un Cliente</Typography>
        </GenericDialog>
    )
}

CustomersDialog.propTypes = {
    handleDialogClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
}

export default CustomersDialog
